import "./App.css";
import './LogsPage.css';
import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, orderBy } from "firebase/firestore";
import { format } from 'date-fns'
import Table from 'react-bootstrap/Table';
import {db} from './firebase';
 
function convertLogTime(logTime) {
    try {
        return logTime.toString();
    } catch (e) {
        return " ";
    }
}

/*
                <div>
                        <input
                            type="text"
                            placeholder="Add a test log"
                            onChange={(e)=>setLog(e.target.value)}
                        />
                    </div>

                    <div className="btn-container">
                        <button
                            type="submit"
                            className="btn"
                            onClick={(e) => {
                                addLog(e);
                                fetchPost();
                                }}
                        >
                            Submit Test Log
                        </button>
                    </div>
*/

const Logs = () => {
    // some way of practicing adding data (using for logs first)
    const [log, setLog] = useState("");
    const [logs, setLogs] = useState([]);
 
    const addLog = async (e) => {
        e.preventDefault();  
       
        try {
            const docRef = await addDoc(collection(db, "test-logs-2"), {
              time: (new Date()).toLocaleDateString() + " " + (new Date()).toLocaleTimeString(),
              log: log,    
            });
            console.log("Document written with ID: ", docRef.id);
          } catch (e) {
            console.error("Error adding document: ", e);
          }
    }
    // fetching logs from the firestore and sorting them by time (newest first)
    // can add filtering based on device id in the future
    const fetchPost = async () => {
        await getDocs(query(collection(db, "test-logs-2"), orderBy("time", "desc")))
            .then((querySnapshot)=>{              
                const newData = querySnapshot.docs
                    .map((doc) => ({...doc.data(), id:doc.id }));
                setLogs(newData);                
                console.log(logs, newData);
            })
       
    }
   
    useEffect(()=>{
        fetchPost();
    }, [])

    // have some way to input logs (for testing purposes to get them to show up)

    return (
        <section className="logs-container">
            <div className="log">
                <h1 className="header">
                    Feedback Logs
                </h1>

                <Table striped bordered hover size="sm" >
                    <thead>
                        <tr>
                        <th>Time Stamp</th>
                        <th>Feedback</th>
                        </tr>
                    </thead>
                    <tbody className="log-content">
                        {
                            logs.map((log,i)=>(
                                <tr key={i}>
                                    <td>{convertLogTime(log.time)}</td>
                                    <td>{log.log}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
        </section>
    )
}
                             
export default Logs
                            